<template>
	<div class="row my-4">
		<div class="col-sm-12 position-relative border border-warning py-2">
			<div class="row">
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setCountry"
						:options="multiSelectState.countriesSelect"
						rules="required"
						name="Country"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>

				<div class="form-group col-sm-6 mb-6">
					<BaseMultiSelect
						@change:value="getCities"
						@update:value="setCity"
						:options="multiSelectState.citiesSelect"
						rules="required"
						name="City"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="from-group col-sm-2">
					<BaseInput
						name="Transport Date"
						label="Transport Date"
						type="date"
						v-model="data.transportDate"
						:min="`${new Date().toISOString().split('T')[0]}`"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="from-group col-sm-2">
					<BaseInput
						name="Drop Date"
						label="Drop Date"
						type="date"
						v-model="data.dropDate"
						:min="
							data.transportDate ||
							`${new Date().getFullYear()}-${
								new Date().getMonth() + 1 < 10
									? '0' + (new Date().getMonth() + 1)
									: new Date().getMonth() + 1
							}-${new Date().getDate() + 1}`
						"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-3">
					<BaseMultiSelect
						@update:value="setTransporter"
						:options="multiSelectState.transportersSelect"
						rules="required"
						name="Transporter"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-3">
					<BaseMultiSelect
						@update:value="setVehicle"
						:options="multiSelectState.vehiclesSelect"
						rules="required"
						name="Vehicle"
						mode="tags"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-2">
					<BaseMultiSelect
						@update:value="setPreference"
						:options="multiSelectState.preferences"
						rules="required"
						name="Preference"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="row">
					<p class="custom-dark-text">Transport Type</p>

					<div class="col-3">
						<input
							class="form-check-input"
							type="radio"
							name="transportType"
							id="Checkbox-ChildrenAge"
							value="Airport Transfers"
							v-model="data.transportType"
						/>
						<label class="form-check-label mx-2 custom-dark-text"
							>Airport Transfers</label
						>
					</div>
					<div class="col-4">
						<input
							class="form-check-input"
							type="radio"
							name="Sightseeing Transfers"
							id="Checkbox-ChildrenAge"
							value="Sightseeing Transfers"
							v-model="data.transportType"
						/>
						<label class="form-check-label mx-2 custom-dark-text"
							>Sightseeing Transfers</label
						>
					</div>
					<div class="col-5 mb-2">
						<input
							class="form-check-input"
							type="radio"
							name="transportType"
							id="Checkbox-ChildrenAge"
							value="Other"
							v-model="data.transportType"
						/>
						<label class="form-check-label mx-2 custom-dark-text">Other</label>
					</div>
					<div v-if="data.transportType === 'Other'" class="col-6">
						<BaseInput
							name="Other"
							label="Other"
							type="text"
							:required="true"
							v-model="data.other"
							class="form-control form-control-lg dashInput"
							rules="required"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>
				</div>
			</div>
			<span
				v-if="count !== 0"
				@click="$emit('removeComponent', count)"
				class="mx-2 position-absolute top-100 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer"
				><i class="bi bi-x"></i
			></span>
		</div>
	</div>
</template>
<script>
	import { reactive, watch } from "vue";
	import Helper from "@/helpers/dataHelper";
	import API from "@/config/api";
	import toast from "@/config/toast";

	import BaseInput from "./BaseInput";
	import BaseMultiSelect from "./BaseMultiSelect";

	export default {
		name: "LeadTransport",
		components: {
			BaseInput,
			BaseMultiSelect,
		},
		props: {
			count: { type: Number, default: 0 },
		},
		emits: ["removeComponent", "updateData"],
		setup: (props, { emit }) => {
			const data = reactive({
				country: {
					id: 0,
					name: null,
				},
				city: {
					id: 0,
					name: null,
				},
				transportType: null,
				transporter: null,
				vehicles: [],
				preference: null,
				transportDate: null,
				dropDate: null,
				other: null,
			});

			watch(
				() => data,
				(preValue, newValue) => {
					if (
						data.country.name &&
						data.city.name &&
						data.transportDate &&
						data.dropDate &&
						((data.transportType && data.transportType !== "Other") ||
							(data.transportType === "Other" && data.other))
					) {
						emit("updateData", { index: props.count, data });
					}
				},
				{ deep: true },
			);

			const multiSelectState = reactive({
				countries: [],
				countriesSelect: [],
				cities: [],
				citiesSelect: [],
				sights: [],
				sightOptions: [],
				preferences: Helper.preferences,
				transporters: [],
				transportersSelect: [],
				vehicles: [],
				vehiclesSelect: [],
			});

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					multiSelectState.countries = countries;
					multiSelectState.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};
			getCountries();

			const setCountry = (dataObj) => {
				if (!dataObj) {
					data.country.id = 0;
					data.country.name = null;
					return;
				}
				// ? finding selected city data
				const country = multiSelectState.countries.filter(
					(country) => country.id === dataObj,
				);
				data.country.id = country[0].id;
				data.country.name = country[0].name;
				getCities();
			};

			// ! City Functions

			const getCities = async (cityObj) => {
				let cityData = {};

				if (cityObj?.name && cityObj.name.length < 3) return;
				else if (cityObj?.name && cityObj.name.length > 3)
					cityData.name = cityObj.name;

				if (data.country.name) {
					cityData.countryName = data.country.name;
				} else if (!cityObj && !data.country.name) return;

				try {
					const cities = await Helper.getCities(cityData);

					multiSelectState.cities = cities;

					const changeFormat = cities.map((city) => {
						return { label: city.name, value: city.id };
					});

					multiSelectState.citiesSelect = [...changeFormat];
				} catch (error) {
					console.log(error);
				}
			};

			const setCity = (dataObj) => {
				if (!dataObj) {
					data.city.id = 0;
					data.city.name = null;
					return;
				}
				const city = multiSelectState.cities.filter(
					(city) => city.id === dataObj,
				);
				data.city.id = city[0].id;
				data.city.name = city[0].name;
				getTransporters(city[0].name);
			};

			const getTransporters = async (city) => {
				try {
					if (!city) throw Error("Please select a city");
					const response = await API.privateRequest.get(
						"transports?city=" + city,
					);
					multiSelectState.transporters = response.data.data;
					multiSelectState.transportersSelect = response.data.data.map(
						(transporter) => {
							return { label: transporter.name, value: transporter._id };
						},
					);
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			const setPreference = (payload) => {
				data.preference = payload;
			};
			const setTransporter = (payload) => {
				data.transporter = payload;

				const transporter = multiSelectState.transporters.filter(
					(transporter) => transporter._id === payload,
				);

				const vehicles = transporter[0].vehicleData.filter(
					(vehicle) => vehicle.city.name === data.city.name,
				);

				multiSelectState.vehicles = vehicles[0].vehicles;
				multiSelectState.vehiclesSelect = multiSelectState.vehicles.map(
					(vehicle) => ({ label: vehicle.vehicleType, value: vehicle._id }),
				);
			};
			const setVehicle = (payload) => {
				data.vehicles = [...payload];
			};

			const inputError = (input) => {};
			const inputSuccess = (input) => {};

			return {
				data,
				multiSelectState,

				setCountry,
				getCities,
				setCity,
				setPreference,
				setTransporter,
				setVehicle,

				inputError,
				inputSuccess,
			};
		},
	};
</script>
